export const ACCENTS = {
  instaflix: {
    primary: "#fda4af",
    glow: "rgba(251,113,133,0.4)",
    bgTint: "rgba(251,113,133,0.08)",
    gradient: "from-rose-300 via-rose-200 to-rose-300",
    shadowClass: "shadow-rose",
  },
  reelsflix: {
    primary: "#c4b5fd",
    glow: "rgba(196,181,253,0.4)",
    bgTint: "rgba(196,181,253,0.08)",
    gradient: "from-violet-300 via-rose-200 to-violet-300",
    shadowClass: "shadow-violet",
  },
  movieflix: {
    primary: "#fde68a",
    glow: "rgba(253,230,138,0.4)",
    bgTint: "rgba(253,230,138,0.08)",
    gradient: "from-amber-200 via-amber-100 to-amber-200",
    shadowClass: "shadow-amber",
  },
} as const;

export type Mode = keyof typeof ACCENTS;
